var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "url(#paint0_linear_194_4655)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61077 16.6814C7.49011 15.6544 9.58797 14.7972 11.5481 13.9357C14.9203 12.5245 18.3059 11.1378 21.7256 9.8468C22.391 9.62684 23.5865 9.41175 23.7037 10.39C23.6395 11.7747 23.3754 13.1513 23.1943 14.5279C22.7346 17.5551 22.2033 20.572 21.6851 23.5893C21.5066 24.5944 20.2376 25.1147 19.4256 24.4715C17.4742 23.1638 15.5077 21.8687 13.5812 20.5307C12.9502 19.8945 13.5354 18.9809 14.099 18.5266C15.7062 16.9551 17.4107 15.62 18.934 13.9674C19.3449 12.983 18.1308 13.8126 17.7303 14.0668C15.53 15.5711 13.3835 17.1673 11.0637 18.4894C9.87871 19.1365 8.4976 18.5835 7.31317 18.2224C6.25119 17.7862 4.69497 17.3467 5.61066 16.6815L5.61077 16.6814Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_194_4655",
    x1: 11.5154,
    y1: -14.8137,
    x2: -10.3534,
    y2: 20.5441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34B0DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E88D3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/TelegramIcon.5e471e3d96121561a59d4c1b6d2349da.svg";
export { ForwardRef as ReactComponent };